<div class="flex-column align-center flex gap-3 text-base">
    <h2>
        {{ 'EXPIRED_TICKET_REMOVE_MODAL_TITLE' | translate }}
    </h2>
    <p>
        {{ 'EXPIRED_TICKET_REMOVE_MODAL_BODY' | translate }}
    </p>
    <div class="flex-column flex gap-3">
        <button
            class="rounded-lg bg-red-600 py-3 text-white dark:bg-contrast-yellow dark:text-black"
            (click)="removeTicket()">
            {{ 'EXPIRED_TICKET_REMOVE_MODAL_BUTTON_CONFIRM' | translate }}
        </button>
        <button
            class="rounded-lg border border-solid border-gray-300 bg-white py-3 text-black dark:border-0 dark:text-contrast-yellow"
            (click)="closeDialog()">
            {{ 'EXPIRED_TICKET_REMOVE_MODAL_BUTTON_CANCEL' | translate }}
        </button>
    </div>
</div>
